<article *transloco="let t">
  @if (article$ | async; as article) {
    <cft-holy-grail-grid>
      <cft-holy-grail-grid-col-left>
        @if (menuData$ | async; as menu) {
          <bgo-article-page-sidenav
            #menu
            class="sticky top-[calc(var(--navbar-height)+2rem)] z-20"
            [topics]="menu.topics"
            [topic]="article.topic"
            [articles]="menu.articles"
          ></bgo-article-page-sidenav>
        }
        @if (tableOfContent$ | async; as toc) {
          @if (toc.length) {
            <cft-table-of-content
              [title]="article.breadcrumbTitle || article.title"
              class="sticky top-28 mt-[calc(100vh-250px)]"
            >
              @for (item of toc; track item.id) {
                <cft-toc-item [anchor]="item.id" [offsetMargin]="250">
                  {{ item.title }}
                </cft-toc-item>
              }
            </cft-table-of-content>
          }
        }
      </cft-holy-grail-grid-col-left>
      <cft-holy-grail-grid-content class="space-y-lg">
        @if (breadcrumbs$ | async; as breadcrumbs) {
          <cft-breadcrumbs [showBackButton]="false" [breadcrumbs]="breadcrumbs"></cft-breadcrumbs>
        }
        <div class="space-y-sm">
          @if (article.readingTime) {
            <cft-chip
              [text]="t('article.readingTimeMinutes', {value: article.readingTime})"
              size="sm"
              colour="grey"
            ></cft-chip>
          }
          <div class="space-y-lg">
            <div>
              <div class="plot-xl">{{ article.topic?.breadcrumbTitle || article.topic?.title }}</div>
              <h1 class="heading-2xl md:heading-4xl">{{ article.title }}</h1>
              <h2 class="mt-sm !font-normal heading-base">
                {{ article.preview }}
              </h2>
            </div>
            <div class="flex items-center justify-between gap-sm border-b border-grey-100 pb-sm">
              <!--Leave the span here even if we don't have authors. It's for the justify-between of the flex box.-->
              <span>
                @if (article.authors.length) {
                  <bgo-authors [authors]="article.authors" class="block"></bgo-authors>
                }
              </span>
              <bgo-share-button
                [buttonText]="t('newStickyFooter.share')"
                [modalTitle]="t('article.share.title')"
                [modalPlot]="t('article.share.plot')"
              ></bgo-share-button>
            </div>
            @if (tableOfContent$ | async; as toc) {
              @if (toc.length > 0) {
                <bgo-article-inline-table-of-content
                  [tableOfContent]="toc"
                  (itemSelected)="scrollToContent($event)"
                  data-testid="table-of-content"
                />
              }
            }
            @if (article.headerImage) {
              <div class="relative h-40 w-full">
                <img
                  [ngSrc]="article.headerImage.url"
                  [alt]="article.headerImage.title"
                  class="h-full w-full rounded-3 object-cover"
                  height="320"
                  width="640"
                  priority
                />
              </div>
            }
            <bgo-rich-text
              [content]="article.content"
              class="mt-lg block"
              data-testid="article-content"
            ></bgo-rich-text>
          </div>
        </div>
      </cft-holy-grail-grid-content>
      <cft-holy-grail-grid-col-right class="!hidden md:!block"> </cft-holy-grail-grid-col-right>
    </cft-holy-grail-grid>

    <div class="fixed bottom-0 z-10 w-full lg:sticky">
      <bgo-new-sticky-footer
        [shareTitle]="t('article.share.title')"
        [sharePlot]="t('article.share.plot')"
        [mainCallToAction]="article.mainCallToAction"
        [secondaryCallToAction]="article.secondaryCallToAction"
      >
        <bgo-new-sticky-footer-content>
          <bgo-value-checkmarks></bgo-value-checkmarks>
        </bgo-new-sticky-footer-content>
      </bgo-new-sticky-footer>
    </div>
  }
</article>
